module.exports = __webpack_public_path__ + "static/media/23154839_1638423612899490_5108082280029942599_o-thumb.3e89fb8e.jpg";